import { useHomePage } from '@/homepage/application';

const HomePage = () => {
  useHomePage();

  return <div />;
};

export { HomePage };
